
import React from 'react';

const Card = ({ title, value, bcolor }) => {
  const cardStyle = {
    backgroundColor: bcolor,
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    textAlign: 'left',
  };

  const cardTitleStyle = {
    fontSize: '1.2em',
    margin: '0 0 8px 0',
    fontWeight: 'bold',
  };

  const cardValueStyle = {
    fontSize: '0.9em',
    margin: '0',
  };

  return (
    <div style={cardStyle}>
      <h3 style={cardTitleStyle}>{title}</h3>
      <p style={cardValueStyle}>{value}</p>
    </div>
  );
};

const Analytics = () => {
  const metrics = [
    { title: 'Total Visits', value: getRandomNumber(1000, 5000), bcolor: '#DFF5E9' },
    { title: 'Unique Visits', value: getRandomNumber(100, 500), bcolor: '#F5ECED' },
    { title: 'Page Views', value: getRandomNumber(50, 200), bcolor: '#FFF8EB' },
    { title: 'Sessions', value: getRandomNumber(10, 50), bcolor: '#E1F6FB' },
    { title: 'Bounce Rate', value: getRandomPercentage(1, 100), bcolor: '#F5ECED' },
    { title: 'Page Load Time', value: getRandomTime(1, 2), bcolor: '#FFF8EB' },
    { title: 'Response Time', value: getRandomTime(100, 500, 'ms'), bcolor: '#E1F6FB' },
  ];
  
  // Function to generate a random number within a range
    function getRandomNumber(min, max, decimals = 0) {
      const factor = Math.pow(10, decimals);
      return (Math.random() * (max - min) + min).toFixed(decimals);
    }
    
    // Function to generate a random percentage
    function getRandomPercentage(min, max) {
      return `${getRandomNumber(min, max)}%`;
    }
    
    // Function to generate a random time
    function getRandomTime(min, max, unit = ' Sec') {
      return `${getRandomNumber(min, max, unit === 'ms' ? 0 : 1)}${unit}`;
    }  

  return (
    <div>
      <h4 className="title">
        Analytics
      </h4>
      <div style={gridStyle}>
        {metrics.map((metric, index) => (
          <Card key={index} title={metric.title} value={metric.value} bcolor={metric.bcolor} />
        ))}
      </div>
    </div>
  );
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: '16px',
  padding: '16px 52px',
};

export default Analytics;
